import { send } from '../../../../../src/network';
import { type Customer } from '../../../../../src/types/Customer';

export { type Customer };

export async function getCustomerSelf() {
  return await send<Customer>({
    method: 'GET',
    path: '/api/v2/customers/self/',
  });
}
